"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RegistrationStatus = void 0;
class RegistrationStatus {
    isRegistered() {
        return this.registered;
    }
    setRegistered(registered) {
        this.registered = registered;
        return this;
    }
    getRegistrationLocation() {
        return this.registrationLocation;
    }
    getRegistrationLocationCode() {
        return this.registrationLocationCode;
    }
    setRegistrationLocationCode(location) {
        this.registrationLocationCode = location;
        return this;
    }
    setRegistrationLocation(location) {
        this.registrationLocation = location;
        return this;
    }
    getExpiryDate() {
        return this.expiryDate;
    }
    setExpiryDate(date) {
        this.expiryDate = date;
        return this;
    }
}
exports.RegistrationStatus = RegistrationStatus;
exports.default = RegistrationStatus;
